import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EquipmentManagement from "@/components/v2/Tasks/Misc/Equipment/EquipmentManagement.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EquipmentManagement))
}
}

})